import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { useEffect, useState } from 'react';

interface UseSignUpModalOptions {
  paramsKey?: string;
}

interface UseSignUpModalReturn {
  showModal: boolean;
  handleModal: (isOpen: boolean) => void;
}

export const useSignUpModal = (options: UseSignUpModalOptions = {}): UseSignUpModalReturn => {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  const { paramsKey = 'show_sign_up' } = options;

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has(paramsKey)) {
      setShowModal(true);
    }
  }, [location.search, paramsKey]);

  const handleModal = (isOpen: boolean) => {
    setShowModal(isOpen);

    const params = new URLSearchParams(location.search);

    if (isOpen) {
      params.set(paramsKey, '');
    } else {
      params.delete(paramsKey);
    }

    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  return { showModal, handleModal };
};
